import { ListView } from './../../../../framework/tools/scrollview/listview';
// import ChatItem from "./chatItem";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ScrollControl extends cc.Component {
    
    
    // @property(cc.ScrollView)
    // scrollView: cc.ScrollView = null;

    // @property(cc.Node)
    // content: cc.Node = null;

    // @property(cc.Node)
    // chatNode: cc.Node = null;
    

    // chatItems: ChatItem[] = []
    // data: any[] = []  //所有聊天数据
    // totalCount = 0  //总共有多少条记录
    // spawnCount = 0  //总循环个数
    // upMaxPosY = 1000  //上限Y轴距离
    // downMaxPosY = -1500 //下限Y轴距离
    // contentLastPos = 0  //记录上次滑动位置
    // isStartCheck: boolean = false //是否开始检查滑动
    // itemOffset = 10  //间距
    // maxIndex=0  //记录当前显示出的最大条数
    // problemTypeList:any[]
    // problemList:any[]
    // // LIFE-CYCLE CALLBACKS:

    // // onLoad () {}

    // start() {

    // }
    // initialize() {

    //     let height=0
    //     for (let i = 0; i < this.spawnCount; i++) {
    //         let item = this.instantiateObj(this.chatNode)
    //         let chatItem = item.getComponent(ChatItem);
    //         chatItem.setData(i, this.data[i])
    //         //cc.log(a)
    //         this.chatItems.push(chatItem)
    //         item.parent = this.content
    //         height+=chatItem.getNodeHeight()
    //     }
        
    //     this.scheduleOnce(() => {
    //         let posY = 0
    //         for (let i = 0; i < this.spawnCount; i++) {
    //             this.content.children[i].position = new cc.Vec2(10, posY)
    //             posY -= this.content.children[i].height + this.itemOffset
    //             //cc.log(posY)
    //         }
    //         this.isStartCheck = true
    //         this.content.setContentSize(1920,height)
    //     },0.2);
    //     this.contentLastPos = this.content.position.y
        
    // }
    // setInitData(data: any[]) {

    //     this.clearData()
    //     this.data = data;
    //     this.totalCount = data.length;
    //     this.spawnCount = this.totalCount >= 15 ? 15 : this.totalCount;
    //     this.initialize();
    // }

    // clearData() {
    //     if (this.chatItems == null) {
    //         return;
    //     }
    //     this.scrollView.scrollToOffset(cc.v2(0, 0), 0.1);
    //     for (let i = 0; i < this.chatItems.length; i++) { // spawn items, we only need to do this once
    //         let item = this.chatItems[i];
    //         item.node.removeFromParent();
    //         item.node.destroy();
    //     }
    // }
    // instantiateObj(prefabNode: cc.Node): cc.Node {
    //     var node = cc.instantiate(prefabNode)
    //     node.position = cc.v2(0, 0)
    //     node.scale = 1

    //     return node
    // }
    // scrollEvet(event: any) {
    //     if (!this.isStartCheck) {
    //         return
    //     }
    //     if (this.contentLastPos > this.content.position.y) {

            
    //         this.checkDwonItem()

    //     }
    //     else 
    //     {
            
    //         this.checkUpItem()
    //     }
    //     this.contentLastPos = this.content.position.y

    // }
    // checkUpItem() {

    //     let tempNode = this.chatItems[0].node
    //     let tempPos = this.getPositionInView(tempNode)
    //     //cc.log("up")
    //     //cc.log(tempPos.y)

    //     if (tempPos.y > this.upMaxPosY + tempNode.height) {
    //         let newY = this.chatItems[this.spawnCount - 1].node.position.y - this.itemOffset - this.chatItems[this.spawnCount - 1].getNodeHeight()
    //         let item = tempNode.getComponent(ChatItem)
    //         let index = item.index
    //         index += this.spawnCount
    //         if (index < this.data.length) {
    //             let startItem = this.chatItems.shift()
    //             startItem.setData(index, this.data[index])
    //             this.chatItems.push(startItem)
    //             startItem.node.position = new cc.Vec2(10, newY)
    //             if(this.maxIndex<index)
    //             {
    //                 this.scrollView.content.height += item.node.height + this.itemOffset
    //                 this.maxIndex=index

    //             }
                
    //             // let posY=this.chatItems[0].node.height+this.itemOffset+this.chatItems[0].node.position.y
    //             // for(let i=1;i<this.chatItems.length;i++)
    //             // {
    //             //     this.chatItems[i].node.position=new cc.Vec2(10,posY)
    //             //     posY+=this.chatItems[i].node.position.y+this.itemOffset+this.chatItems[i].node.height
    //             // }
                
    //         }
    //     }
        

    // }
    // checkDwonItem() {

    //     let tempNode = this.chatItems[this.spawnCount-1].node
    //     let tempPos = this.getPositionInView(tempNode)

    //     //cc.log("down")

    //      if (tempPos.y < this.downMaxPosY) 
    //      {
    //         let newY = this.chatItems[0].node.position.y + this.itemOffset
    //         let item = tempNode.getComponent(ChatItem)
    //         let index = item.index
    //         index -= this.spawnCount
    //         if(index>=0 && this.chatItems[0].index>0)
    //         {
    //             let startItem = this.chatItems.pop()
    //             startItem.setData(index, this.data[index])
    //             this.chatItems.unshift(startItem)

    //             startItem.node.position = new cc.Vec2(10, newY+startItem.getNodeHeight())
    //         }
      
    //     }
    // }
    // getPositionInView(item) {
    //     let worldPos = item.parent.convertToWorldSpaceAR(item.position);
    //     let viewPos = this.scrollView.node.convertToNodeSpaceAR(worldPos);
    //     return viewPos;
    // }
    // setProblemType(problemType: any[]) {//显示咨询列表

    //     this.problemTypeList=problemType
    //     let item = this.instantiateObj(this.chatNode)
    //     item.parent=this.content
    //     let chatItem = item.getComponent(ChatItem);
    //     chatItem.showProblemType(problemType)
    //     let height=this.getNewPosY()
    //     this.content.setContentSize(1920,height)
    // }
    // setProblemList(data: any[]) { //显示常见问题
    //     this.problemList=data
    //     let item = this.instantiateObj(this.chatNode)
    //     let posY=this.getNewPosY()
    //     item.parent=this.content
    //     let chatItem = item.getComponent(ChatItem);
    //     chatItem.showProblemList(data)
    //     item.position=new cc.Vec2(10,-posY)

    //     let height=this.getNewPosY()
    //     this.content.setContentSize(1920,height)
    // }
    // addItem(data: any) {
    //     let item = this.instantiateObj(this.chatNode)
    //     let posY=this.getNewPosY()
       
    //     item.getComponent(ChatItem).setData(this.content.childrenCount,data)

    //     item.parent=this.content
    //     item.position=new cc.Vec2(10,-posY)

    //     let height=this.getNewPosY()
    //     this.content.setContentSize(1920,height)
    // }

    // addAnwerItem(txt: string) { //
    //     let item = this.instantiateObj(this.chatNode)
    //     let posY=this.getNewPosY()
        
    //     let data:any={}
    //     data.type=2
    //     data.content=txt
    //     data.anwer=true;
    //     item.getComponent(ChatItem).setData(this.content.childrenCount,data)

    //     item.parent=this.content
    //     item.position=new cc.Vec2(10,-posY)

    //     let height=this.getNewPosY()
    //     this.content.setContentSize(1920,height)
    // }
    // getNewPosY()
    // {
    //     let posY=0
    //     for(let i=0;i<this.content.childrenCount;i++)
    //     {
    //         let item=this.content.children[i].getComponent(ChatItem)
    //         posY+=item.getNodeHeight()           
    //     }
    //     return posY
    // }
}
